import React, { useContext } from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { ThemeContext } from "./Theme/context";
export interface LineChartData {
  firstData: number[];
  secondData: number[];
  thirdData: number[];
  fourthData: number[];
  xLabel: string[];
}
export const LineChartComponent: React.FC<{
  data: LineChartData;
}> = ({ data }) => {
  const themeContext = useContext(ThemeContext);
  return (
    <LineChart
      height={340}
      series={[
        {
          data: data.firstData,
          color: "#41ECCD",
          yAxisId: 'leftAxisId',
          showMark: false,
        },
        {
          data: data.secondData,
          color: "#41B9EC",
          yAxisId: 'rightAxisId',
          showMark: false,
        },
        {
          data: data.thirdData,
          color: "#6775F0",
          yAxisId: 'rightAxisId',
          showMark: false,
        },
        {
          data: data.fourthData,
          color: "#ECBC41",
          yAxisId: 'rightAxisId',
          showMark: false,
        },
      ]}
      xAxis={[
        {
          scaleType: "point",
          data: data.xLabel,
          labelFontSize: 14,
          labelStyle: { fill: "red" },
        },
      ]}
      yAxis={[
        {
          id: "leftAxisId",
          labelFontSize: 14,
        },
        {
          id: "rightAxisId",
          labelFontSize: 14,
        },
      ]}
      sx={{
        color: themeContext?.theme.color,
        "& .MuiChartsAxis-tickLabel": {
          fill: themeContext?.theme.color + " !important",
        },
        "& .MuiChartsGrid-line": {
          stroke: "#27318E !important",
        },
        "& .MuiChartsGrid-root": {
          stroke: "#27318E !important",
        },
        "& .MuiChartsAxis-line": {
          stroke: "#27318E !important",
        },
      }}
      rightAxis="rightAxisId"
      grid={{ vertical: false, horizontal: true }}
    />
  );
};
